import { redirect } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { resolveSession } from './session';

/**
 * A `beforeLoad` that sends anybody `allowed` refuses to the dashboard — so a typed URL, a
 * bookmark or a `g` chord lands where the rail would have sent them, rather than on a screen
 * whose every request the server now refuses.
 *
 * The server's guard is the control; this is what keeps it from being the first thing somebody
 * meets.
 */
export function requireAccess(allowed: (roles: readonly string[]) => boolean) {
  return async ({ context }: { context: { queryClient: QueryClient } }): Promise<void> => {
    const session = await resolveSession(context.queryClient);
    // No session is the root guard's business — it sends them to sign in.
    if (session === null) return;
    if (!allowed(session.roles)) throw redirect({ to: '/', replace: true });
  };
}
